import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridContainer from 'components/UI/Grid/GridContainer';
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import Muted from 'components/UI/Typography/Muted';
import Card from 'components/UI/Card/Card';
import CardHeader from 'components/UI/Card/CardHeader';
import CardIcon from 'components/UI/Card/CardIcon';
import CardFooter from 'components/UI/Card/CardFooter';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
// material-ui icons
import Clock from '@material-ui/icons/QueryBuilder';
import Refresh from '@material-ui/icons/Refresh';
import User from '@material-ui/icons/PermIdentity';
import CalendarToday from '@material-ui/icons/CalendarToday';
import Edit from '@material-ui/icons/Edit';
// styles
import DashboardStyles from 'assets/jss/material-dashboard-pro-react/views/dashboardStyle';

const metricsRange = [
  { title: 'date.last_day', value: 'last_day' },
  { title: 'date.last_week', value: 'last_week' },
  { title: 'date.last_month', value: 'last_month' },
];
class Stats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      range: metricsRange[0],
    };
  }

  /**
   * @description
   * Called when user tap the Edit range button.
   * @param {string} range - Selected value.
   */
  handleUpdateData = range => {
    const { statsUpdate } = this.props;
    let minDateTime = null;
    const maxDateTime = moment();
    switch (range.value) {
      case 'last_day':
        minDateTime = moment().subtract(1, 'd');
        break;
      case 'last_week':
        minDateTime = moment().subtract(1, 'week');
        break;

      case 'last_month':
        minDateTime = moment().subtract(1, 'month');
        break;

      default:
        break;
    }
    this.setState({ range }, () => {
      statsUpdate({ minDateTime, maxDateTime });
    });
  };

  render() {
    const { classes, data, color, icon, title, t } = this.props;
    const { range } = this.state;
    const updatedOn = moment();
    return (
      <Card>
        <CardHeader icon stats>
          <CardIcon color={color}>{icon}</CardIcon>
          <h6 className={classes.cardCategory}>{title}</h6>
          <h3 className={classes.cardTitle}>{data}</h3>
        </CardHeader>

        <CardFooter>
          <FormControl fullWidth className={classes.selectFormControl}>
            <Select
              autoWidth
              classes={{
                select: classes.select,
                icon: classes.selectIcon,
              }}
              renderValue={value => (
                <Muted>
                  <CalendarToday />
                  {value}
                </Muted>
              )}
              value={t(range.title)}
              onChange={event => {
                this.handleUpdateData(event.target.value);
              }}
              IconComponent={Edit}
              inputProps={{
                id: 'selectRangeStats',
              }}
            >
              {metricsRange.map(item => (
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected,
                  }}
                  value={item}
                  key={item.value}
                >
                  {t(item.title)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </CardFooter>
        <CardFooter stats>
          <GridContainer justify="space-between" alignItems="center">
            <GridItem xs={9} sm={10} md={9} lg={9}>
              <Muted>
                <Clock />
                Actualizado{' '}
                <Moment fromNow ago>
                  {updatedOn}
                </Moment>
              </Muted>
            </GridItem>
            <GridItem xs={3} sm={2} md={3} lg={3}>
              <Button
                className={classes.actionBtns}
                justIcon
                simple
                color="primary"
                onClick={() => this.handleUpdateData(range)}
              >
                <Refresh />
              </Button>
            </GridItem>
          </GridContainer>
        </CardFooter>
      </Card>
    );
  }
}

/**
 * Stats PropTypes
 * @param classes - prop styles received from withStyles
 * @param data - prop data received from parent
 * @param title - graph title
 * @param color - color of the icon container
 * @param icon - icon to show in the header
 * @callback statsUpdate - called when button Update or edited date is pressed.
 */

Stats.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.number.isRequired,
  statsUpdate: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  color: PropTypes.string,
  icon: PropTypes.node,
  t: PropTypes.func.isRequired,
};

Stats.defaultProps = {
  color: 'primary',
  icon: <User />,
};

export default withTranslation()(withStyles(DashboardStyles)(Stats));
